import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";

import { EDIT_ASSIGNOR_VALIDATION } from "./Validations";
import ImageUpload from "../elements/ImageUpload";
import { isValid } from "date-fns";
import { isValidURL } from "../../utils/helperFunctions";

interface EditProfileAssignorFormProps {
  initialValues: {
    name: string;
    email: string;
    phone: string;
    image?: string;
  };
  onClose: () => void;
  onSubmit: (values: {
    name: string;
    email: string;
    phone: string;
    image?: string;
  }) => void;
}

const EditProfileAssignorForm: React.FC<EditProfileAssignorFormProps> = ({
  initialValues,
  onClose,
  onSubmit,
}) => {
  const [imageBase64, setImageBase64] = useState(initialValues.image || "");

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={EDIT_ASSIGNOR_VALIDATION}
      onSubmit={(values) => {
        const { image, ...rest } = values;

        onSubmit({
          ...rest,
          ...(!isValidURL(imageBase64) && { image: imageBase64 }),
        });
      }}
    >
      {({ isValid, dirty }) => (
        <Form className="flex flex-col">
          <div className="px-6">
            <label className="block text-sm text-grey-700 font-semibold mb-1">
              Name:
            </label>
            <Field
              name="name"
              className="w-full p-2 border-2 rounded-lg cursor-not-allowed"
              disabled
            />
            <ErrorMessage
              name="name"
              component="div"
              className="text-red-500"
            />
          </div>

          <div className="px-6">
            <label className="block text-sm text-grey-700 font-semibold mb-1 mt-2">
              Phone number:
            </label>
            <Field name="phone" className="w-full p-2 border-2 rounded-lg" />
            <ErrorMessage
              name="phone"
              component="div"
              className="text-red-500"
            />
          </div>

          <div className="px-6 mb-5">
            <label className="block text-sm text-grey-700 font-semibold mb-1 mt-2">
              Email:
            </label>
            <Field
              name="email"
              type="email"
              className="w-full p-2 border-2 rounded-lg cursor-not-allowed"
              disabled
            />
            <ErrorMessage
              name="email"
              component="div"
              className="text-red-500"
            />
          </div>

          <ImageUpload
            userImage={imageBase64}
            onBase64Image={(base64) => setImageBase64(base64)}
          />

          <div className="px-6 flex flex-col mt-3">
            <button
              type="submit"
              className="mb-2 blue-button w-full py-2 bg-blue-500 text-white font-semibold rounded-lg"
              // disabled={!isValid || !dirty}
              disabled={
                !isValid || (!dirty && imageBase64 === initialValues.image)
              }
            >
              Save changes
            </button>
            <button
              style={{ background: "white" }}
              type="button"
              onClick={onClose}
              className="py-1 mb-2 bg-white border rounded-lg font-semibold"
            >
              Cancel
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default EditProfileAssignorForm;
